import { jwtDecode } from "jwt-decode";

class AuthService {
  static TOKEN_KEY = "supplyvet_token";
  static USER_KEY = "supplyvet_user";

  static setToken(token) {
    if (token) {
      localStorage.setItem(this.TOKEN_KEY, token);
      localStorage.setItem("token", token);
    }
  }

  static getToken() {
    return localStorage.getItem(this.TOKEN_KEY) || localStorage.getItem("token");
  }

  static removeToken() {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem("token");
  }

  static isTokenValid(token = null) {
    const tokenToCheck = token || this.getToken();
    if (!tokenToCheck) return false;

    try {
      const decoded = jwtDecode(tokenToCheck);
      const currentTime = Date.now() / 1000;
      return decoded.exp > currentTime;
    } catch (error) {
      console.warn("Token invalide:", error);
      return false;
    }
  }

  static getTokenPayload(token = null) {
    const tokenToCheck = token || this.getToken();
    if (!tokenToCheck) return null;

    try {
      return jwtDecode(tokenToCheck);
    } catch (error) {
      console.warn("Impossible de décoder le token:", error);
      return null;
    }
  }

  static setUser(user) {
    if (user) {
      localStorage.setItem(this.USER_KEY, JSON.stringify(user));
    }
  }

  static getUser() {
    const userData = localStorage.getItem(this.USER_KEY);
    return userData ? JSON.parse(userData) : null;
  }

  static removeUser() {
    localStorage.removeItem(this.USER_KEY);
  }

  static clearAuthData() {
    this.removeToken();
    this.removeUser();
  }

  static isAuthenticated() {
    const token = this.getToken();
    return token && this.isTokenValid(token);
  }

  static migrateOldTokens() {
    const oldToken = localStorage.getItem("token");
    if (oldToken && !localStorage.getItem(this.TOKEN_KEY)) {
      localStorage.setItem(this.TOKEN_KEY, oldToken);
    }
  }

  static getUserChannel() {
    const payload = this.getTokenPayload();
    if (!payload || !payload.roles) {
      return "supplyvet";
    }

    if (payload.roles.includes("CODE_VETERINAIRES") || payload.roles.includes("CODE_DELEGUES")) {
      return "supplyvet";
    }

    return "esupplyvet";
  }

  static isVeterinaire() {
    const payload = this.getTokenPayload();
    return payload?.roles?.includes("CODE_VETERINAIRES") || false;
  }

  static isClient() {
    return !this.isVeterinaire();
  }

   static isDelegue() {
    const payload = this.getTokenPayload();
    return payload?.roles?.includes("CODE_DELEGUES") || false;
  }
  
}

export default AuthService;
